<div class="modal-signup modal-content" *ngIf="model=='Add'">
  <div>
   
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


        <div class="card-header wh-header padding-bottom-0px padding-right-5px padding-left-10px">
          <div class="row">
            <div class="col-md-4 padding-right-0px">
              Embryos In My Store
            </div>
            <div class="col-md-7 padding-right-0px">
              <!--<button type="submit" class="btn font-size-13px actions-btn-prime float-right">Save</button>-->
            </div>
            <div class="col-md-1">
              <button type="button" class="close margin-right-10px" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>




        </div>

        <div class="modal-body padding-top-0px">
          <div class="row">
            <div class="col-md-12 ">
              <div class="table-component">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero">

                    <thead class="">
                      <tr>
                        <th class="padding-top-4px padding-bottom-4px font-size-12px">DOC &amp; Date  </th>
                        <!--<th class="padding-top-4px padding-bottom-4px font-size-12px"></th>-->
                        <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Cell Stage (or) Embryo Stage</th>
                        <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                        <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                        <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Transfer Count</th>




                        <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>

                        <th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>


                      </tr>
                    </thead>
                    <tbody class="table-body">

                      <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController">
                        <td class="td-padding padding-all-0px ">
                          <div>{{l.DOC}}</div>
                          <div> {{l.LastModifiedTime|date:'MMM-dd-yyyy'}}</div>

                        </td>


                     

                        <td class="padding-top-0px padding-bottom-0px">{{l.CellStage}}</td>

                        <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                          {{l.EmbryoCount}}
                        </td>
                        <td class="padding-top-0px padding-bottom-0px">
                          <label>{{l.Grade1}}{{l.Grade2}}</label>
                        </td>
                        <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                          <label>{{l.TransferCount}}</label>
                        </td>
                        <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">{{l.AvailableCount}}</td>
                        <td>
                          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3" (click)="EditStore2(l)"> <i class="fas fa-ellipsis-h"></i></button>

                        </td>



                      </tr>
                    </tbody>

                  </table>

                </div>
              </div>

            </div>
          </div>

        

        </div>
    <!--<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
  </div>-->
    </div>
      
  </div>
  </div>
<div class="modal-signup modal-content" *ngIf="Select">
  <div>
    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


        <div class="card-header wh-header padding-bottom-0px padding-right-5px padding-left-10px">
          <div class="row">
            <div class="col-md-4 padding-right-0px">
              Edit
            </div>
            <div class="col-md-7 padding-right-0px">
              <button type="submit" class="btn font-size-13px actions-btn-prime float-right">Save</button>
            </div>
            <div class="col-md-1">
              <button type="button" class="close margin-right-10px" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>




        </div>

        <div class="modal-body padding-top-0px">
          <div class="row border-top-1px border-bottom-1px">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">Date: {{Date| date:'MMM-dd-yyyy'}}</label></div>
            </div>
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">Cycle Number : {{Cyclenumber}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">DOC : {{DOC}}</label></div>
            </div>
          </div>


          <div class="row my-profile-form margin-top-10">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Embryo Count </label>
                </div>:
                <div class="col-md-3">

                  <!--<CodeTypeValue CodeType="1to20" id="CurrentSaveEmbryoStoreInfoRequest.Count"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.Count" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.Count"
                                 name="CurrentSaveEmbryoStoreInfoRequest.Count" required>

                  </CodeTypeValue>-->
                  <label>{{Embryocount}}</label>

                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-5px" *ngIf="DOC==2 || DOC==3 || DOC==4 "> Cell Stage </label>
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-5px" *ngIf="DOC==5 || DOC==6 "> Stage </label>
                </div>
                <div class="col-md-3">

                  <CodeTypeValue CodeType="IVFCS" id="CurrentSaveEmbryoStoreInfoRequest.CellStage"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.CellStage" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.CellStage"
                                 name="CurrentSaveEmbryoStoreInfoRequest.CellStage" required>

                  </CodeTypeValue>

                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> Grade </label>
                </div>:
                <div class="col-md-3">

                  <label>{{Grade1}}{{Grade2}}</label>


                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> ReGrade </label>
                </div>
                <div class="col-md-3">
                  <!--<CodeTypeValue CodeType="D{{DOC}}GR1"></CodeTypeValue>-->
                  <CodeTypeValue CodeType="D{{DOC}}GR1" id="CurrentSaveEmbryoStoreInfoRequest.ReGrade"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.ReGrade" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.ReGrade"
                                 name="CurrentSaveEmbryoStoreInfoRequest.ReGrade" required>

                  </CodeTypeValue>

                </div>
                <div class="col-md-3" *ngIf="DOC>4">
                  <CodeTypeValue CodeType="D{{DOC}}GR2"id="CurrentSaveEmbryoStoreInfoRequest.ReGrade2"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.ReGrade2" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.ReGrade2"
                                 name="CurrentSaveEmbryoStoreInfoRequest.ReGrade2"
                                 ></CodeTypeValue>

                </div>

              </div>

            </div>
          </div>
          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Transfer Count </label>
                </div>
                <div class="col-md-3">
                  <!--<CodeTypeValue CodeType="D{{DOC}}GR1"></CodeTypeValue>-->
                  <input type="number" class="form-control" placeholder="Transfer Count"
                         id="CurrentSaveEmbryoStoreInfoRequest.Count"
                         [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.Count" required
                         name="CurrentSaveEmbryoStoreInfoRequest.Count" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                 

                </div>
            

              </div>

            </div>
          </div>
          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> Remarks </label>
                </div>
                <div class="col-md-3">
                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                            name="CurrentSaveEmbryoStoreInfoRequest.Remarks"
                            [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.Remarks" required minlength="1" maxlength="100"
                            #addconcerns_text="ngModel"></textarea>
                  <small class="form-text text-danger"
                         *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                </div>


              </div>

            </div>
          </div>


        </div>
        <!--<div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
        </div>-->
      </div>
    </form>
  </div>
</div>
